import { render, staticRenderFns } from "./ActiveAlertsList.vue?vue&type=template&id=4f21fc0e"
import script from "./ActiveAlertsList.vue?vue&type=script&lang=js"
export * from "./ActiveAlertsList.vue?vue&type=script&lang=js"
import style0 from "./ActiveAlertsList.vue?vue&type=style&index=0&id=4f21fc0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports